/* CONDITIONS */
export const GET_CONDITIONS = "GET_CONDITIONS"
export const GET_CONDITIONS_SUCCESS = "GET_CONDITIONS_SUCCESS"
export const GET_CONDITIONS_FAIL = "GET_CONDITIONS_FAIL"